import React from 'react';

const NoFinalistsFound: React.FC = () => {
  return (
    <div className="p-8 text-center">
      <div className="w-16 h-16 bg-gray-200 rounded-full flex items-center justify-center mx-auto mb-4">
        <svg
          className="w-8 h-8 text-gray-400"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
          />
        </svg>
      </div>
      <h3 className="text-lg font-baijamjuree font-bold text-gray-900 mb-2">
        No finalists found
      </h3>
      <p className="text-gray-600 font-baijamjuree">
        No finalists match the current filter criteria.
      </p>
    </div>
  );
};

export default NoFinalistsFound;
